(() => {
  document
    .querySelectorAll<HTMLElement>("[data-default-teaser]")
    .forEach((teaser) => {
      const link = teaser.querySelector("a")?.href;

      teaser.addEventListener("click", () => {
        if (link) window.location.href = link;
      });
    });
})();

export {};
